import { render, staticRenderFns } from "./GalleryIndex.vue?vue&type=template&id=2413660c&scoped=true"
import script from "./GalleryIndex.vue?vue&type=script&lang=js"
export * from "./GalleryIndex.vue?vue&type=script&lang=js"
import style0 from "./GalleryIndex.vue?vue&type=style&index=0&id=2413660c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2413660c",
  null
  
)

export default component.exports